import { postListItemComp } from "./components/post.component";
import { getPosts } from "./services/post.service";

let currentPage = 2;
let pageSize = 9;

const renderPosts = (posts) => {
  const postList = document.getElementById("post-list");
  posts.forEach((post) => {
    const listItem = postListItemComp(post);
    postList.appendChild(listItem);
  });
};

export const loadPostsFromBtn = () => {
  const loadMoreButton = document.getElementById("load-more-btn");
  const postsNotFound = document.getElementById("posts-notfound");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", async () => {
      loadMoreButton.disabled = true;
      loadMoreButton.innerHTML = 'Cargando... <div class="spinner"></div>';
      const posts = await getPosts(currentPage, pageSize);
      if (posts.length === 0) {
        loadMoreButton.remove();
        postsNotFound.style.display = 'block';
        postsNotFound.innerText = 'No se encontraron más publicaciones';
      } else {
        renderPosts(posts);
        currentPage++;
        loadMoreButton.disabled = false;
        loadMoreButton.innerHTML = "Cargar más";
      }
    });
  }
};
